import { Route } from '@angular/router';
import { Path } from '../../../common/constants/paths.constant';
import { rfqDetailsResolver } from '../../../common/resolvers/rfq-details.resolver';
import { supplierPoDetailsResolver } from '../../../common/resolvers/po-details/po-details.resolver';
import { quotationDetailsResolver } from '../../../common/resolvers/quotation-details/quotation-details.resolver';
import { inspectionCaseResolver } from '../../../common/resolvers/inspection-case/inspection-case.resolver';

export const supplierRoutes: Route[] = [
  {
    path: '',
    redirectTo: `/${localStorage.getItem('lang') ?? 'ar'}/${Path.SUPPLIER}/${Path.DASHBOARD}`,
    pathMatch: 'full',
  },
  {
    path: Path.DASHBOARD,
    loadComponent: () =>
      import('../../../pages/dashboard/supplier/dashboard/dashboard.component').then(
        c => c.DashboardComponent
      ),
  },
  {
    path: Path.RFQ.RFQ,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/supplier/received-rfq-board/received-rfq-board.component').then(
            c => c.ReceivedRfqBoardComponent
          ),
      },
      {
        // The groupId scopes the screen to one split RFQ; without it the
        // supplier would see every group they were invited to on this RFQ.
        path: `${Path.RFQ.DETAILS}/:rfqId/:groupId`,
        data: { role: 'supplier' },
        loadComponent: () =>
          import('../../../common/components/rfq-details-view/rfq-details-view.component').then(
            c => c.RfqDetailsViewComponent
          ),
        resolve: {
          rfqDetails: rfqDetailsResolver,
        },
      },
      {
        path: `${Path.RFQ.DETAILS}/:rfqId`,
        data: { role: 'supplier' },
        loadComponent: () =>
          import('../../../common/components/rfq-details-view/rfq-details-view.component').then(
            c => c.RfqDetailsViewComponent
          ),
        resolve: {
          rfqDetails: rfqDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.QUOTATION.QUOTATION_RFQ,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/supplier/quotations/quotations.component').then(
            C => C.QuotationsComponent
          ),
      },
      {
        // A quotation belongs to one group, so links carry it where they know
        // it; the shorter route stays for those that do not.
        path: `${Path.QUOTATION.DETAILS}/:rfqId/:groupId/:quotationId`,
        loadComponent: () =>
          import('../../../pages/dashboard/supplier/quotations/quotation-details-view/quotation-details-view.component').then(
            c => c.QuotationDetailsViewComponent
          ),
        resolve: {
          data: quotationDetailsResolver,
        },
      },
      {
        path: `${Path.QUOTATION.DETAILS}/:rfqId/:quotationId`,
        loadComponent: () =>
          import('../../../pages/dashboard/supplier/quotations/quotation-details-view/quotation-details-view.component').then(
            c => c.QuotationDetailsViewComponent
          ),
        resolve: {
          data: quotationDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.PO.PO_RFQ,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../../../pages/dashboard/supplier/purchased-order/purchased-order-board/purchased-order-board.component').then(
            C => C.PurchasedOrderBoardComponent
          ),
      },
      {
        path: `${Path.PO.DETAILS}/:id`,
        loadComponent: () =>
          import('../../../pages/dashboard/supplier/purchased-order/purchased-order-details/purchased-order-details.component').then(
            C => C.PurchasedOrderDetailsComponent
          ),
        resolve: {
          poDetails: supplierPoDetailsResolver,
        },
      },
    ],
  },
  {
    path: Path.INSPECTION.CASES,
    data: { role: 'supplier' },
    loadComponent: () =>
      import('../../../common/pages/inspection-case-list/inspection-case-list.component').then(
        m => m.InspectionCaseListComponent
      ),
  },
  {
    path: `${Path.INSPECTION.CASES}/:caseId`,
    data: { role: 'supplier' },
    loadComponent: () =>
      import('../../../common/pages/inspection-case/inspection-case.component').then(
        m => m.InspectionCaseComponent
      ),
    resolve: {
      inspectionCase: inspectionCaseResolver,
    },
  },
  {
    path: Path.WALLET.WALLET,
    loadComponent: () =>
      import('../../../pages/dashboard/supplier/wallet/wallet.component').then(
        c => c.WalletComponent
      ),
  },
  {
    path: Path.WALLET.WALLET + '/:id',
    loadComponent: () =>
      import('../../../pages/dashboard/supplier/wallet/wallet.component').then(
        c => c.WalletComponent
      ),
  },
  {
    path: Path.MY_SERVICES,
    loadComponent: () =>
      import('../../../pages/dashboard/supplier/my-services/my-services.component').then(
        c => c.MyServicesComponent
      ),
  },
  {
    path: Path.ACCOUNT,
    loadComponent: () =>
      import('../../../pages/dashboard/supplier/supplier-account/supplier-account.component').then(
        c => c.SupplierAccountComponent
      ),
  },
];
